export const FETCH_COIN_TASKS_REQUEST = 'FETCH_COIN_TASKS_REQUEST';
export const FETCH_COIN_TASKS_SUCCESS = 'FETCH_COIN_TASKS_SUCCESS';
export const FETCH_COIN_TASKS_FAILURE = 'FETCH_COIN_TASKS_FAILURE';
